import { defineComponent as _defineComponent } from 'vue'
import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["title"]

import type { Component } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'MenuItem',
  props: {
    icon: {},
    title: {},
    action: { type: Function },
    isActive: { type: Function }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    class: _normalizeClass(["menu-item", { 'is-active': _ctx.isActive ? _ctx.isActive() : null }]),
    title: _ctx.title,
    type: "button",
    onClick: _cache[0] || (_cache[0] = () => _ctx.action())
  }, [
    (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.icon)))
  ], 10, _hoisted_1))
}
}

})